import styles from './styles';

import React from 'react';
import type { RouteComponentProps } from 'react-router';

import type { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core';

import LoadingPanel from 'bz-core-controls/controls/layout/loading-panel';

import AuthStore from 'bz-stores/lib/auth-store';
import { withRouter } from 'react-router-dom';
export interface IParams {
  redirectParam?: string;
  token?: string;
}

export interface IProps extends WithStyles<typeof styles>, RouteComponentProps<IParams> {}

class AutoLogin extends React.Component<IProps> {
  componentDidMount() {
    const { token, redirectParam } = this.props.match.params;
    AuthStore.autoLogin(token, redirectParam);
  }

  render() {
    return (
      <div className={this.props.classes.container}>
        <h2>Logging you in now...</h2>
        <LoadingPanel loading={true} />
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(AutoLogin));
